<template>

    <v-page-stripe service="stripe" />

</template>

<script>

import PageSettingsIntegrationsEdit from '@pages/settings-integrations/PageSettingsIntegrationsEdit';

export default {

    components: {
        'v-page-stripe': PageSettingsIntegrationsEdit,
    },

}

</script>